module.exports = __webpack_public_path__ + "static/media/gambina.1be40fee.png";


//////////////////
// WEBPACK FOOTER
// ./src/gambina.png
// module id = 252
// module chunks = 0